
import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ShopPage = lazy(() => import('../pages/shop/page'));
const HoodiesPage = lazy(() => import('../pages/hoodies/page'));
const TeesPage = lazy(() => import('../pages/tees/page'));
const ProductPage = lazy(() => import('../pages/product/page'));
const CartPage = lazy(() => import('../pages/cart/page'));
const CheckoutPage = lazy(() => import('../pages/checkout/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const WishlistPage = lazy(() => import('../pages/wishlist/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));

const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-black"></div>
  </div>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Suspense fallback={<LoadingSpinner />}><HomePage /></Suspense>,
  },
  {
    path: '/shop',
    element: <Suspense fallback={<LoadingSpinner />}><ShopPage /></Suspense>,
  },
  {
    path: '/hoodies',
    element: <Suspense fallback={<LoadingSpinner />}><HoodiesPage /></Suspense>,
  },
  {
    path: '/tees',
    element: <Suspense fallback={<LoadingSpinner />}><TeesPage /></Suspense>,
  },
  {
    path: '/product/:id',
    element: <Suspense fallback={<LoadingSpinner />}><ProductPage /></Suspense>,
  },
  {
    path: '/cart',
    element: <Suspense fallback={<LoadingSpinner />}><CartPage /></Suspense>,
  },
  {
    path: '/checkout',
    element: <Suspense fallback={<LoadingSpinner />}><CheckoutPage /></Suspense>,
  },
  {
    path: '/about',
    element: <Suspense fallback={<LoadingSpinner />}><AboutPage /></Suspense>,
  },
  {
    path: '/contact',
    element: <Suspense fallback={<LoadingSpinner />}><ContactPage /></Suspense>,
  },
  {
    path: '/wishlist',
    element: <Suspense fallback={<LoadingSpinner />}><WishlistPage /></Suspense>,
  },
  {
    path: '/privacy',
    element: <Suspense fallback={<LoadingSpinner />}><PrivacyPage /></Suspense>,
  },
  {
    path: '/terms',
    element: <Suspense fallback={<LoadingSpinner />}><TermsPage /></Suspense>,
  },
  {
    path: '*',
    element: <Suspense fallback={<LoadingSpinner />}><NotFoundPage /></Suspense>,
  },
];

export default routes;
